import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLineChart2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLineChart2"><Path fillRule="evenodd" clipRule="evenodd" d="M10.0005 4L10.0005 20H8.00055L8.00055 4L10.0005 4ZM22.0005 7V20L20.0005 20V7H22.0005ZM4.00549 10.0005L4 20.0005L2 19.9995L2.00549 9.99945L4.00549 10.0005ZM15.9984 13V20H13.9984V13H15.9984Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLineChart2;
